import { useNavigate } from "react-router-dom"




const NotFound = () => {
    const navigate = useNavigate();


  return (
    <div>

    <div>NotFound</div>
    <button onClick={()=> navigate('/')}>back to login</button>
    </div>
  )
}

export default NotFound